/* eslint-disable */
/*
* flights.js
*
* Description: Holds 'Stores' Logic for Module:'Crewplanning2 - Calendar'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { eventBus } from '../../../main';
import {
    CONF_CALENDAR_AIRCRAFTS,
    CONF_CLIENT
} from '../../../config';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> flights -- scheduler ---------------------------
    flights_Events: [],
    flights_Events_Filtered: [],
    flights_Resources: [],
    flights_Resources_Filtered: [],
    flights_Dependencies_Filtered: [],

    // >>> flights -- legs --------------------------------
    flights_Legs: [], // calls response
    flights_Leg_Tmp: [], //

    // >>> flights -- search/filter -----------------------
    // {code: "D-ASGK",         idAircraft: 285},
    // {code: "D-ASMR",         idAircraft: 286},
    // {code: "D-ANNA",         idAircraft: 289},
    // {code: "D-ASSB",         idAircraft: 292},
    // {code: "D-ASSM",         idAircraft: 293},
    // {code: "KSF-FSEAT 319",  idAircraft: 294},
    flights_FilterTerms_DaysAndCo: {
        "aircrafts": CONF_CALENDAR_AIRCRAFTS,
        "days": [],
        "types": [],
        "deleted": false,
    },

    flights_FilterTerms_LegsAndFlightNo: {
        "leg": '',
        "flightNo": ''
    },
    // >>> flights -- FlightLabelContent ------------------
    flights_FlightLabelContent: 'FlightNo',

    // >>> flights - multi selected events ----------------
    selectedMultiEventsFlights: [], // multiEventSelect
    selectedMultiEventsEntireRecordFlights: [], // multiEventSelect (entire Rrcord)
    selectedMultiResourcesFlights: [], // Multi Reources Select

    // >>> flights - crew details, crew member details ----
    flights_CrewDetails_SavedPayload: {}, // User asked Payload
    flights_CrewDetails: [],
    flights_CrewDetails_Reduced: [],
    flights_CrewDetails_DutiesChecks: [],
    flights_CrewDetails_HoursReport: [],
    flights_CrewDetails_ErrorsOnResourceIsLoaded: false,

    // >>> flights - resource details ---------------------
    flights_ResourceDetails_Brief: [],
    flights_ResourceDetails_ResourceAskedFor: {},
    flights_ResourceDetails_ResourceAskedFor_Date_EventRecord: null,
    flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker: null,

    flights_ResourceDetails_TrainingsList: [], // Tab 6
    flights_ResourceDetails_EarlyNightDutiesYearlyList: {}, // Tab 7
    flights_ResourceDetails_ReportsYearlyList: {}, // Tab 4
    flights_ResourceDetails_FlightDutyTimeConfig: {}, // Tab 2

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: Events/Resources
    ***************************************************************************/
    /***************************************************************************
    * get_flights_Resources_Filtered()
    *
    * Desc: Return filtered Resources. Resources === Aircrafts.
    * Note: // -1 = a wins
    * Note: // 1  = b wins
    *
    */
    get_flights_Resources_Filtered: state => {

        // sort by capacity and name
        state.flights_Resources_Filtered = state.flights_Resources_Filtered.sort((a, b) => {

            if (a.capacityY > b.capacityY) {
                return -1;
            }
            if (a.capacityY < b.capacityY) {
                return 1;
            }

            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        });


        // "sort" by company to "split" between SUNDAIR and FLYAIR
        // everything with "SUB" goes to the bottom
        state.flights_Resources_Filtered = state.flights_Resources_Filtered.sort((a, b) => {

            // FLYAIR and SUNDAIR
            if (a.name.includes('SUB') === false && b.name.includes('SUB') === false) {
                if (a.name.startsWith('FlyAir') === true && b.name.startsWith('FlyAir') === true) {
                    return 0;
                }
                if (a.name.startsWith('FlyAir') === false && b.name.startsWith('FlyAir') === true) {
                    return -1;
                }
                if (a.name.startsWith('FlyAir') === true && b.name.startsWith('FlyAir') === false) {
                    return 1;
                }
            }
            if (a.name.includes('SUB') === false && b.name.includes('SUB') === false) {
                if (a.name.startsWith('D-') === true && b.name.startsWith('D-') === true) {
                    return 0;
                }
                if (a.name.startsWith('D-') === false && b.name.startsWith('D-') === true) {
                    return -1;
                }
                if (a.name.startsWith('D-') === true && b.name.startsWith('D-') === false) {
                    return 1;
                }
            }

            // SUBs
            if (a.name.includes('SUB') === true && a.name > b.name) {
                return 1;
            }
            if (b.name.includes('SUB') === true && a.name < b.name) {
                return -1;
            }

        });


        return state.flights_Resources_Filtered;

    }, // eo function get_flights_Resources_Filtered()



    /***************************************************************************
    * get_flights_Events_Filtered()
    *
    * Desc: Return Events.
    * Note: Events === Flights
    *
    */
    get_flights_Events_Filtered: state => {

        return state.flights_Events_Filtered;

    }, // eo function get_flights_Events_Filtered()




    /***************************************************************************
    * Getters: Events/Resources
    ***************************************************************************/
    /***************************************************************************
    * get_flights_FlightLabelContent()
    *
    * Desc: Return Flight Label Content.
    * Note:
    *
    */
    get_flights_FlightLabelContent: state => {

        return state.flights_FlightLabelContent;

    }, // eof get_flights_FlightLabelContent()




    /***************************************************************************
    * Getters: 'Flights' - Get selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * get_selectedMultiEventsFlights()
    *
    * Desc: Return selected Multi Events.
    * Note: paylod:: e.g.: 'HOTEL'
    * Note: Getter with Payload.
    *
    */
    get_selectedMultiEventsFlights: state => payload => {

        if (payload !== undefined && payload !== null) {
            return state.selectedMultiEventsFlights.filter(x => x.name == payload);
        } else {
            return state.selectedMultiEventsFlights;
        }

    }, // eo function get_selectedMultiEventsFlights()


    /***************************************************************************
    * get_selectedMultiEventsEntireRecordFlights()
    *
    * Desc: Return selected Multi Events. (entire Records)
    *
    */
    get_selectedMultiEventsEntireRecordFlights: state => {

        return state.selectedMultiEventsEntireRecordFlights;

    }, // eo function get_selectedMultiEventsEntireRecordFlights()


    /***************************************************************************
    * get_selectedMultiResourcesFlights()
    *
    * Desc: Return selected Multi Resources.
    *
    */
    get_selectedMultiResourcesFlights: state => {

        return state.selectedMultiResourcesFlights;

    }, // eo function get_selectedMultiResourcesFlights()




    /***************************************************************************
    * Getters:  'Flights' - 'Crew Details' - 'Crew Member Details'
    ***************************************************************************/
    /***************************************************************************
    * get_flights_CrewDetails_SavedPayload()
    *
    * Desc: Returns Crew Details => Users asked Payload.
    * Note:
    */
    get_flights_CrewDetails_SavedPayload: state => {

        return state.flights_CrewDetails_SavedPayload;

    }, // eo function get_flights_CrewDetails_SavedPayload()


    /***************************************************************************
    * get_flights_CrewDetails()
    *
    * Desc: Returns Crew Details.
    * Note:
    */
    get_flights_CrewDetails: state => {

        // >>> compare func for sorting array -------------
        function compare(a, b) {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }

            if (a.genLastname < b.genLastname) {
                return -1;
            }
            if (a.genLastname > b.genLastname) {
                return 1;
            }

            return 0;
        }


        return state.flights_CrewDetails.sort(compare);

    }, // eo function get_flights_CrewDetails()


    /***************************************************************************
    * get_flights_CrewDetails_Reduced()
    *
    * Desc: Returns Crew Details (reduced).
    * Note:
    */
    get_flights_CrewDetails_Reduced: state => {

        // >>> compare func for sorting array -------------
        function compare(a, b) {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }

            if (a.lastName < b.lastName) {
                return -1;
            }
            if (a.lastName > b.lastName) {
                return 1;
            }



            return 0;
        }


        return state.flights_CrewDetails_Reduced.sort(compare);

    }, // eo function get_flights_CrewDetails_Reduced()


    /***************************************************************************
    * get_flights_CrewDetails_Department()
    *
    * Desc: Returns Department of User.
    * Note:
    */
    get_flights_CrewDetails_Department: state => payload => {

        let idHrDepartment = null;


        state.flights_CrewDetails.forEach(member => {
            if (member.id === payload) {
                idHrDepartment = member.idHrDepartment
            }
        });


        return idHrDepartment;

    }, // eo function get_flights_CrewDetails_Department()


    /***************************************************************************
    * get_flights_CrewDetails_DutiesCheck()
    *
    * Desc: Returns Crew Details DutiesChecks.
    * Note:
    */
    get_flights_CrewDetails_DutiesCheck: state => {

        return state.flights_CrewDetails_DutiesCheck;

    }, // eo function get_flights_CrewDetails_DutiesCheck()


    /***************************************************************************
    * get_flights_CrewDetails_HoursReport()
    *
    * Desc: Returns Crew Details Hours Report.
    * Note:
    */
    get_flights_CrewDetails_HoursReport: state => {

        return state.flights_CrewDetails_HoursReport;

    }, // eo function get_flights_CrewDetails_HoursReport()


    /***************************************************************************
    * get_flights_CrewDetails_ErrorsOnResourceIsLoaded()
    *
    * Desc: Returns
    * Note:
    */
    get_flights_CrewDetails_ErrorsOnResourceIsLoaded: state => {

        return state.flights_CrewDetails_ErrorsOnResourceIsLoaded;

    }, // eo function get_flights_CrewDetails_ErrorsOnResourceIsLoaded()




    /***************************************************************************
    * Getters: 'Flights' - 'Resource Details'
    ***************************************************************************/
    /***************************************************************************
    * get_flights_ResourceDetails_ResourceAskedFor()
    *
    * Desc: Returns Resource Details 'someone looked for'.
    * Note:
    */
    get_flights_ResourceDetails_ResourceAskedFor: state => {

        return state.flights_ResourceDetails_ResourceAskedFor;

    }, // eo function get_flights_ResourceDetails_ResourceAskedFor()

    /***************************************************************************
    * get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord()
    *
    * Desc:
    * Note:
    */
    get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord: state => {

        return state.flights_ResourceDetails_ResourceAskedFor_Date_EventRecord;

    }, // eo function get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord()

    /***************************************************************************
    * get_flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker()
    *
    * Desc:
    * Note:
    */
    get_flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker: state => {

        return state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker;

    }, // eo function get_flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker()


    /***************************************************************************
    * get_flights_ResourceDetails_TrainingsList()
    *
    * Desc: Returns Resource Details Trainings List.
    * Note:
    */
    get_flights_ResourceDetails_TrainingsList: state => {

        return state.flights_ResourceDetails_TrainingsList;

    }, // eo function get_flights_ResourceDetails_TrainingsList()


    /***************************************************************************
    * get_flights_ResourceDetails_EarlyNightDutiesYearlyList()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_EarlyNightDutiesYearlyList: state => {

        return state.flights_ResourceDetails_EarlyNightDutiesYearlyList;

    }, // eo function get_flights_ResourceDetails_EarlyNightDutiesYearlyList()


    /***************************************************************************
    * get_flights_ResourceDetails_ReportsYearlyList()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_ReportsYearlyList: state => {

        return state.flights_ResourceDetails_ReportsYearlyList;

    }, // eo function get_flights_ResourceDetails_ReportsYearlyList()





    /*************************************************************************** 'Brief'
    * get_flights_BriefDetails_Standbys_ThisDay()
    *
    * Desc: Return 'Standbys this Day'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_Standbys_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.standBy;

    }, // eo function get_flights_BriefDetails_Standbys_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_Flights_ThisDay()
    *
    * Desc: Return 'Flights this Day'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_Flights_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.flights;

    }, // eo function get_flights_BriefDetails_Flights_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_Sectors_ThisDay()
    *
    * Desc: Return 'Sectors this Day'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_Sectors_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.sectors;

    }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_TotalDT_ThisDay()
    *
    * Desc: Return 'Total DT this Day'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_TotalDT_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.dt;

    }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_TotalFT_ThisDay()
    *
    * Desc: Return 'Total DT this Day'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_TotalFT_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.ft;

    }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_FlightDutyTime_FdtInfo()
    *
    * Desc: Return ''. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_FlightDutyTime_FdtInfo: state => {

        return state.flights_ResourceDetails_Brief.fdtInfo;

    }, // eo function get_flights_BriefDetails_FlightDutyTime_FdtInfo()


    /***************************************************************************
    * get_flights_BriefDetails_EarlyNight_ThisDay()
    *
    * Desc: Return 'Early NIght & Co'. Part of Brief Call.
    * Note:
    *
    *
    */
    get_flights_BriefDetails_EarlyNight_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.earlyNightDutyInfo;

    }, // eo function get_flights_BriefDetails_EarlyNight_ThisDay()



    /***************************************************************************
    * get_flights_ResourceDetails_FlightDutyTimeConfig()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_FlightDutyTimeConfig: state => {

        return state.flights_ResourceDetails_FlightDutyTimeConfig;

    }, // eo function get_flights_ResourceDetails_FlightDutyTimeConfig()


    /***************************************************************************
    * get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum: state => {

        return state.flights_ResourceDetails_Brief.resourceDutyAddendum;

    }, // eo function get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum()


    /***************************************************************************
    * get_flights_BriefDetails_PreviousRestPeriod_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_PreviousRestPeriod_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.previousRestPeriod;

    }, // eo function get_flights_BriefDetails_PreviousRestPeriod_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.minimumPreviousRestPeriod;

    }, // eo function get_flights_BriefDetails_MinimumPreviousRestPeriod_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_NextRestPeriod_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_NextRestPeriod_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.nextRestPeriod;

    }, // eo function get_flights_BriefDetails_NextRestPeriod_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.minimumNextRestPeriod;

    }, // eo function get_flights_BriefDetails_MinimumNextRestPeriod_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_DutyCheckin_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_DutyCheckin_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.dutyCheckin;

    }, // eo function get_flights_BriefDetails_DutyCheckin_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_DutyCheckout_ThisDay()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_DutyCheckout_ThisDay: state => {

        return state.flights_ResourceDetails_Brief.dutyCheckout;

    }, // eo function get_flights_BriefDetails_DutyCheckout_ThisDay()


    /***************************************************************************
    * get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed: state => {

        return state.flights_ResourceDetails_Brief.weekOffsetFdtExtensionsUsed;

    }, // eo function get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed()


    /***************************************************************************
    * get_flights_ResourceDetails_PreviousRecRest1()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_PreviousRecRest1: state => {

        return state.flights_ResourceDetails_Brief.previousRecRest1;

    }, // eo function get_flights_ResourceDetails_PreviousRecRest1()


    /***************************************************************************
    * get_flights_ResourceDetails_NextRecRest1()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_NextRecRest1: state => {

        return state.flights_ResourceDetails_Brief.nextRecRest1;

    }, // eo function get_flights_ResourceDetails_NextRecRest1()


    /***************************************************************************
    * get_flights_ResourceDetails_PreviousRec1Duration()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_PreviousRec1Duration: state => {

        return state.flights_ResourceDetails_Brief.previousRec1Duration;

    }, // eo function get_flights_ResourceDetails_PreviousRec1Duration()


    /***************************************************************************
    * get_flights_ResourceDetails_NextRec1Duration()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_NextRec1Duration: state => {

        return state.flights_ResourceDetails_Brief.nextRec1Duration;

    }, // eo function get_flights_ResourceDetails_NextRec1Duration()


    /***************************************************************************
    * get_flights_ResourceDetails_MinimumRestRec1()
    *
    * Desc: Return
    * Note:
    *
    *
    */
     get_flights_ResourceDetails_MinimumRestRec1: state => {

        return state.flights_ResourceDetails_Brief.minimumRestRec1;

    }, // eo function get_flights_ResourceDetails_MinimumRestRec1()



    /***************************************************************************
    * get_flights_ResourceDetails_TimeBetweenRecRest1()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_TimeBetweenRecRest1: state => {

        return state.flights_ResourceDetails_Brief.timeBetweenRecRest1;

    }, // eo function get_flights_ResourceDetails_TimeBetweenRecRest1()


    /***************************************************************************
    * get_flights_ResourceDetails_MaxBetweenRestRec1()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_MaxBetweenRestRec1: state => {

        return state.flights_ResourceDetails_Brief.maxBetweenRestRec1;

    }, // eo function get_flights_ResourceDetails_MaxBetweenRestRec1()


    /***************************************************************************
    * get_flights_ResourceDetails_ES_LF_ND_count()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_ES_LF_ND_count: state => {

        return state.flights_ResourceDetails_Brief.ES_LF_ND_count;

    }, // eo function get_flights_ResourceDetails_ES_LF_ND_count()


    /***************************************************************************
    * get_flights_ResourceDetails_ResRest2()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_ResRest2: state => {

        return state.flights_ResourceDetails_Brief.resRest2;

    }, // eo function get_flights_ResourceDetails_ResRest2()


    /***************************************************************************
    * get_flights_ResourceDetails_MinResRest2()
    *
    * Desc: Return
    * Note:
    *
    *
    */
    get_flights_ResourceDetails_MinResRest2: state => {

        return state.flights_ResourceDetails_Brief.minResRest2;

    }, // eo function get_flights_ResourceDetails_MinResRest2()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: Events/Resources
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getLegsInfo()
    *
    * Desc: Build 'events & 'resources' &  'dependencies' after getLegsInfo Call.
    * Note:
    * Note: COMMERCIAL  (67aaf9)
    * Note: POSITIONAL  (P, 67aaf9 (old), ?? (New) flightModus P)
    * Note: TECHNICAL   (d11149, flightModus E)
    * Note: FERRY       (F, c7ddf7, flightModus F)
    *
    * Note: Filter Legs 'AC & ''BA' out.
    * TODO: CHECK TRIA with Overnights and last Day in Calendar!
    *
    */
    mut_call_getLegsInfo: (state, payload) => {

        let tmp_aircraftConfigs = payload.context.rootState.shared.people_aircraftConfigs,
            tmp_Resources = [],
            bubblename = null;


        // >>> Legs into State ----------------------------
        state.flights_Legs = payload.payload.legs.filter(leg => leg.name !== 'AC' && leg.name !== 'BA'); // save all

        // >>> Aircraft => Build Resources ----------------
        tmp_aircraftConfigs.forEach((aircraft) => {
            bubblename = aircraft.code.split(' ');
            bubblename = bubblename && bubblename.length > 1 ? bubblename[1] : bubblename;
            tmp_Resources.push(
                {
                    "id": aircraft.idAircraft,
                    "idAircraft": aircraft.id,
                    "name": aircraft.code,
                    "bubblename": bubblename,
                    "type": "Sales",
                    "eventColor": "#2d3e52",
                    "capacityC": aircraft.capacityC,
                    "capacityY": aircraft.capacityY
                },
            )
        });
        state.flights_Resources = tmp_Resources;


        // >>> Mutations ----------------------------------
        payload.context.commit('mut_build_Events', { payload: payload });
        payload.context.commit('mut_filter_Resources');
        payload.context.commit('mut_filter_Events');

    }, // eo function mut_call_getLegsInfo()


    /***************************************************************************
    * mut_build_Events()
    *
    * Desc:
    * Note: 'build_EventsInFlights' is used several times.
    *
    */
    mut_build_Events: (state, payload) => {

        let tmp_Events = [];


        tmp_Events = Vue.prototype.$build_EventsInFlights(state.flights_Legs);
        state.flights_Events = tmp_Events;

    }, // eo function mut_build_Events()




    /***************************************************************************
    * Mutations: Filter Events/Resources
    ***************************************************************************/
    /***************************************************************************
    * mut_filter_Resources()
    *
    * Desc: Filters the selected Resources (Aircrafts).
    * Note:
    *
    */
    mut_filter_Resources: (state, payload) => {

        const filterAircrafts = (resource) => {
            let applyFilter = false;


            if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.aircrafts.length > 0) {
                if (state.flights_FilterTerms_DaysAndCo.aircrafts.includes(resource.id)) {
                    applyFilter = true;
                }
            }
            if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.aircrafts.length === 0) {
                applyFilter = true;
            }

            return applyFilter;

        };


        state.flights_Resources_Filtered = state.flights_Resources.filter(resource => filterAircrafts(resource));

    }, // eo function mut_filter_Resources()


    /***************************************************************************
    * mut_filter_Events()
    *
    * Desc: Filters the selected Events.
    * Note:
    *
    */
    mut_filter_Events: (state, payload) => {


        // >>> -------------------------------------------- Day&Co
        const filterDays = (event) => {
            let applyFilter = false;


            if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.days.length > 0) {
                if (state.flights_FilterTerms_DaysAndCo.days.includes(dayjs(event.startDate).get('day'))) {
                    applyFilter = true;
                }
            }
            if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.days.length === 0) {
                applyFilter = true;
            }

            return applyFilter;

        };

        // const filterTypes = (event) => {
        //     let applyFilter = false;


        //     if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.types.length > 0) {
        //         if (state.flights_FilterTerms_DaysAndCo.types.includes(event.legInfo.flightModus)) {
        //             applyFilter = true;
        //         }
        //     }
        //     if (state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.types.length === 0) {
        //         applyFilter = true;
        //     }

        //     return applyFilter;

        // };


        // >>> -------------------------------------------- Leg&FlightNo
        const filterLeg = (event) => {
            let applyFilter = false;


            if (state.flights_FilterTerms_LegsAndFlightNo && state.flights_FilterTerms_LegsAndFlightNo.leg.length > 0) {
                if (event.legInfo.leg.toUpperCase().includes(state.flights_FilterTerms_LegsAndFlightNo.leg)) {
                    applyFilter = true;
                }
            }
            if (state.flights_FilterTerms_LegsAndFlightNo && state.flights_FilterTerms_LegsAndFlightNo.leg.length === 0) {
                applyFilter = true;
            }

            return applyFilter;

        };

        const filterFlightNo = (event) => {
            let applyFilter = false;


            if (state.flights_FilterTerms_LegsAndFlightNo && state.flights_FilterTerms_LegsAndFlightNo.flightNo.length > 0) {
                if (event.legInfo.flightNo.toUpperCase().includes(state.flights_FilterTerms_LegsAndFlightNo.flightNo)) {
                    applyFilter = true;
                }
            }
            if (state.flights_FilterTerms_LegsAndFlightNo && state.flights_FilterTerms_LegsAndFlightNo.flightNo.length === 0) {
                applyFilter = true;
            }

            return applyFilter;

        };



        const filterDeleted = (event) => {

            let applyFilter = false;


            if(state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.deleted === true) {
                applyFilter = true; // deleted filter set to true means "show all flights"
            }
            if(state.flights_FilterTerms_DaysAndCo && state.flights_FilterTerms_DaysAndCo.deleted === false) {
                if (event.legInfo.deleted === null) {
                    applyFilter = true;
                }
            }


            return applyFilter;

        };



        state.flights_Events_Filtered = state.flights_Events.filter(event => filterDays(event));
        // commented out - see #126
        // state.flights_Events_Filtered = state.flights_Events_Filtered.filter(event => filterTypes(event));
        state.flights_Events_Filtered = state.flights_Events_Filtered.filter(event => filterDeleted(event));
        state.flights_Events_Filtered = state.flights_Events_Filtered.filter(event => filterLeg(event));
        state.flights_Events_Filtered = state.flights_Events_Filtered.filter(event => filterFlightNo(event));

    }, // eo function mut_filter_Events()




    /***************************************************************************
    * Mutations: 'Flights' - Set selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * mut_set_SelectedMultiEvents_Flights()
    *
    * Desc: Set selected Multi Events (Flights).
    * Note:
    *
    */
    mut_set_SelectedMultiEvents_Flights: (context, payload) => {

        state.selectedMultiEventsEntireRecordFlights = []; // reset
        state.selectedMultiEventsFlights = []; // reset

        payload.forEach((item, i) => {
            state.selectedMultiEventsEntireRecordFlights.push(item); // entire record
            state.selectedMultiEventsFlights.push(item.data); // data only
        });

    }, // eo function mut_set_SelectedMultiEvents_Flights()


    /***************************************************************************
    * mut_set_SelectedMultiResources_Flights()
    *
    * Desc: Set selected Multi Resources (Flights).
    * Note:
    *
    */
    mut_set_SelectedMultiResources_Flights: (context, payload) => {

        state.selectedMultiResourcesFlights = []; // reset
        payload.forEach((item, i) => {
            state.selectedMultiResourcesFlights.push(item);
        });

    }, // eo function mut_set_SelectedMultiResources_Flights()




    /***************************************************************************
    * Mutations: 'Flights' -  Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_Flights();
    *
    * Desc: Reset everything Flights related.
    * Note:
    */
    mut_reset_Flights: (state, payload) => {

        // >>> flights -- scheduler ---------------------------
        state.flights_Events = [],
        state.flights_Events_Filtered = [],
        state.flights_Resources = [],
        state.flights_Resources_Filtered = [],
        state.flights_Dependencies_Filtered = [],

        // >>> flights -- legs --------------------------------
        state.flights_Legs = [], // calls response
        state.flights_Leg_Tmp = [], //

        // >>> flights -- search/filter -----------------------
        state.flights_FilterTerms_DaysAndCo =  {
            "aircrafts": [],
            "days": [],
            "types": [],
            "deleted": false,
        };

        state.flights_FilterTerms_LegsAndFlightNo =  {
            "leg": '',
            "flightNo": ''
        };

    }, // eo function mut_reset_Flights()


    /***************************************************************************
    * mut_reset_SchedulerDataFlights()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_SchedulerDataFlights: (state, payload) => {

        state.flights_Events = [];
        state.flights_Events_Filtered = [];
        state.flights_Resources = [];
        state.flights_Resources_Filtered = [];
        state.flights_Dependencies_Filtered = [];

    }, // eo function mut_reset_SchedulerDataFlights()




    /***************************************************************************
    * Mutations:
    ***************************************************************************/
    /***************************************************************************
    * mut_set_FlightLabelContent()
    *
    * Desc: Set Flight Label Content.
    * Note:
    *
    */
    mut_set_FlightLabelContent: (state, payload) => {

        state.flights_FlightLabelContent = payload;

    }, // eo function mut_set_FlightLabelContent()




    /***************************************************************************
    * Mutations:
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_SelectedMultiEventsFlights()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_SelectedMultiEventsFlights: (state, payload) => {

        state.selectedMultiEventsFlights = []; // multiEventSelect
        state.selectedMultiEventsEntireRecordFlights = []; // multiEventSelect (entire Rrcord)
        state.selectedMultiResourcesFlights = []; // Multi Reources Select

    }, // eo function mut_reset_SelectedMultiEventsFlights()




    /***************************************************************************
    * Mutations:  'Flights' - 'Crew Details' - 'Crew Member Details'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getCrewDetailsFromFlightSavePayload()
    *
    * Desc: Save Payload User asked for.
    * Note:
    *
    */
    mut_call_getCrewDetailsFromFlightSavePayload: (state, payload) => {

        state.flights_CrewDetails_SavedPayload = payload.payload;

    }, // eo function mut_call_getCrewDetailsFromFlightSavePayload()


    /***************************************************************************
    * mut_call_getCrewDetailsFromFlight()
    *
    * Desc: Save Response Data from ''
    * Note:
    *
    */
    mut_call_getCrewDetailsFromFlight: (state, payload) => {

        let order = null,
            filterableName = null,
            filterableFunc = null;


        payload.payload.forEach((item, i) => {
            filterableName = item.genLastname + ', ' + item.genFirstName + ' (' + item.contract3Code + ')';
            filterableName += item.experienced === true ? '' : '*';
            item.filterableName = filterableName; // add 'filterableName'

            filterableFunc = item.contractFunction + ', ' + item.contractAddFunction;
            item.filterableFunc = filterableFunc; // add 'filterableFunc'

            // >>> ---------------------------------------- // sort resources
            if (item.contractFunction === 'CP') {
                order = '1';
            } else if (item.contractFunction === 'FO') {
                order = '2';
            } else if (item.contractFunction === 'SCCM') {
                order = '3';
            } else if (item.contractFunction === 'CA') {
                order = '4';
            }
            item.order = order;

        });


        state.flights_CrewDetails = payload.payload;

    }, // eo function mut_call_getCrewDetailsFromFlight()


    /***************************************************************************
    * mut_call_getCrewDetailsFromFlight_Reduced()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getCrewDetailsFromFlight_Reduced: (state, payload) => {

        let order = null,
            filterableName = null;


        payload.payload.forEach((item, i) => {
            filterableName = item.lastName + ', ' + item.firstName + ' (' + item.contract3Code + '), ' + item.position;
            item.filterableName = filterableName; // add 'filterableName'

            // >>> ---------------------------------------- // sort resources
            if (item.position === 'CP') {
                order = '1';
            } else if (item.position === 'FO') {
                order = '2';
            } else if (item.position === 'SCCM') {
                order = '3';
            } else if (item.position === 'CA') {
                order = '4';
            }
            item.order = order;

        });


        state.flights_CrewDetails_Reduced = payload.payload;

    }, // eo function mut_call_getCrewDetailsFromFlight_Reduced()


    /***************************************************************************
    * mut_call_getCrewDetailsDutiesCheck()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getCrewDetailsDutiesCheck: (state, payload) => {

        state.flights_CrewDetails_DutiesChecks = payload.payload;

    }, // eo function mut_call_getCrewDetailsDutiesCheck()


    /***************************************************************************
    * mut_call_getCrewDetailsHoursReport()
    *
    * Desc:
    * Note: Add Infos from 'Hours Report' Call into CrewDetails.
    * Note: Add Add Infos from 'DutiesCheck' Call into CrewDetails.
    * Note: Add Add Infos from 'GetLegsInfo' Call into CrewDetails.
    *
    */
    mut_call_getCrewDetailsHoursReport: (state, payload) => {

        let flights_CrewDetails_Copy = [...state.flights_CrewDetails];


        state.flights_CrewDetails_HoursReport = payload.payload; // save


        // >>> 1) add from 'hours report into 'crew details'
        flights_CrewDetails_Copy.forEach((crewmember, i) => {
            payload.payload.forEach(res => {
                if (res.idResource === crewmember.id) {
                    crewmember.flightHoursFormatted = res.flightHoursFormatted;
                    crewmember.fdpHoursFormatted = res.fdpHoursFormatted;
                    crewmember.dutyHoursFormatted = res.dutyHoursFormatted;
                    crewmember.CIDate = dayjs(res.CIDate).utc().format('HH:mm');
                    crewmember.CODate = dayjs(res.CODate).utc().format('HH:mm');
                    crewmember.CIDate_unchanged = res.CIDate;
                    crewmember.CODate_unchanged  = res.CODate;
                    crewmember.fdpExtended = res.fdpExtended;
                }
            });
        });


        // >>> 2) add from 'dutiescheck' into 'crew details'
        flights_CrewDetails_Copy.forEach((crewmember, i) => {
            state.flights_CrewDetails_DutiesChecks.forEach(res => {
                if (res.idResource === crewmember.id) {
                    crewmember.flyingToday = res.flyingToday;
                    crewmember.proceeding = res.proceeding;
                    crewmember.hotel = res.hotel;
                }
            })
        });


        state.flights_CrewDetails = flights_CrewDetails_Copy; // replace

    }, // eo function mut_call_getCrewDetailsHoursReport()


    /***************************************************************************
    * mut_call_getValidateExtends()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getValidateExtends: (state, payload) => {

        let flights_CrewDetails_Copy = [...state.flights_CrewDetails];


        flights_CrewDetails_Copy.forEach((crewmember, i) => {
            crewmember.error = '';
            payload.payload.errors.forEach(err => {
                if (crewmember.id === err.idResource) {
                    crewmember.error += err.restrictions.join(', ') + '; ';
                }
            });

        });


        state.flights_CrewDetails = flights_CrewDetails_Copy; // replace
        state.flights_CrewDetails_ErrorsOnResourceIsLoaded = true; // save it

    }, // eo function mut_call_getValidateExtends()




    /***************************************************************************
    * Mutations: 'Flights' - 'Resource Details'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getCrewDetailsResourceBrief()
    *
    * Desc:
    * Note: Fill up 'Ressource User asked for'.
    *
    */
    mut_call_getCrewDetailsResourceBrief: (state, payload) => {


        // >>> ----------------------------------
        if (payload.params && payload.params.idResource) {
            state.flights_ResourceDetails_ResourceAskedFor = payload.params; // save resource asked for (id)
        }
        if (payload && payload.dateeventrecord) {
            state.flights_ResourceDetails_ResourceAskedFor_Date_EventRecord = payload.dateeventrecord; // save resource asked for (date, eventrecord)
        }
        if (payload && payload.datebriefpicker) {
            state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker = payload.datebriefpicker; // save resource asked for (date, briefpciker)
        }

        // >>> ----------------------------------
        state.flights_ResourceDetails_Brief = payload.response;                 // save brief infos

        // >>> ----------------------------------
        state.flights_CrewDetails.forEach(member => {                           // enhance resource asked for
            if (member.id === state.flights_ResourceDetails_ResourceAskedFor.idResource) {
                state.flights_ResourceDetails_ResourceAskedFor.genFirstName = member.genFirstName;
                state.flights_ResourceDetails_ResourceAskedFor.genLastname = member.genLastname;
                state.flights_ResourceDetails_ResourceAskedFor.contractFunction = member.contractFunction;
                state.flights_ResourceDetails_ResourceAskedFor.comPhone1 = member.comPhone1;
            }
        });

    }, // eo function mut_call_getCrewDetailsResourceBrief()


    /***************************************************************************
    * mut_call_getResourcesTrainingsList()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getResourcesTrainingsList: (state, payload) => {

        state.flights_ResourceDetails_TrainingsList = payload.response; // save trainings list

    }, // eo function mut_call_getResourcesTrainingsList()


    /***************************************************************************
    * mut_call_getResourcesEarlyNightDutiesYearlyList()
    *
    * Desc: Build 'Earyl Night Duties Yearly'.
    * Note:
    *
    */
    mut_call_getResourcesEarlyNightDutiesYearlyList: (state, payload) => {

        let flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy = {},
            january = [],
            february = [],
            march = [],
            april = [],
            may = [],
            june = [],
            july = [],
            august = [],
            september = [],
            october = [],
            november = [],
            december = [];


        // >>> compare func for sorting array -------------
        function compare(a, b) {
            if (a.date < b.date) {
                return -1;
            }
            if (a.date > b.date) {
                return 1;
            }
            return 0;
        }


        // >>> run/find -----------------------------------
        payload.response.forEach(fhs => {
            if (moment(fhs.date).format("MM") === '01') {
                january.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '02') {
                february.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '03') {
                march.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '04') {
                april.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '05') {
                may.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '06') {
                june.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '07') {
                july.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '08') {
                august.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '09') {
                september.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '10') {
                october.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if (moment(fhs.date).format("MM") === '11') {
                november.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
            if ((moment(fhs.date).format("MM") === '12') && (moment(fhs.date).format("YYYY") === payload.year)) {
                december.push({ date: moment(fhs.date).format(), ESsectors: fhs.ESsectors, LFsectors: fhs.LFsectors, NDsectors: fhs.NDsectors });
            }
        });


        // >>> sort/append --------------------------------
        january.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.january = january;
        february.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.february = february;
        march.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.march = march;
        april.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.april = april;
        may.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.may = may;
        june.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.june = june;
        july.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.july = july;
        august.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.august = august;
        september.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.september = september;
        october.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.october = october;
        november.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.november = november;
        december.sort(compare);
        flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy.december = december;


        // >>> state --------------------------------------
        state.flights_ResourceDetails_EarlyNightDutiesYearlyList = flights_ResourceDetails_EarlyNightDutiesYearlyList_Copy;

    }, // eo function mut_call_getResourcesEarlyNightDutiesYearlyList()


    /***************************************************************************
    * mut_call_getResourcesReportYearlyList()
    *
    * Desc: Build 'Early Night Duties Yearly'.
    * Note:
    *
    */
    mut_call_getResourcesReportYearlyList: (state, payload) => {

        let flights_ResourceDetails_ReportsYearlyList_Copy = {},
            january = [],
            february = [],
            march = [],
            april = [],
            may = [],
            june = [],
            july = [],
            august = [],
            september = [],
            october = [],
            november = [],
            december = [];


        // >>> compare func for sorting array -------------
        function compare(a, b) {
            if (a.date < b.date) {
                return -1;
            }
            if (a.date > b.date) {
                return 1;
            }
            return 0;
        }


        // >>> run/find -----------------------------------
        payload.response.forEach(fhs => {
            if (moment(fhs.date).format("MM") === '01') {
                january.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '02') {
                february.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '03') {
                march.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '04') {
                april.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '05') {
                may.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '06') {
                june.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '07') {
                july.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '08') {
                august.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '09') {
                september.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '10') {
                october.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if (moment(fhs.date).format("MM") === '11') {
                november.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
            if ((moment(fhs.date).format("MM") === '12') && (moment(fhs.date).format("YYYY") === payload.year)) {
                december.push({ date: moment(fhs.date).format(), ft: fhs.ft, dt: fhs.dt });
            }
        });


        // >>> sort/append --------------------------------
        january.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.january = january;
        february.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.february = february;
        march.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.march = march;
        april.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.april = april;
        may.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.may = may;
        june.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.june = june;
        july.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.july = july;
        august.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.august = august;
        september.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.september = september;
        october.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.october = october;
        november.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.november = november;
        december.sort(compare);
        flights_ResourceDetails_ReportsYearlyList_Copy.december = december;


        // >>> state --------------------------------------
        state.flights_ResourceDetails_ReportsYearlyList = flights_ResourceDetails_ReportsYearlyList_Copy;

    }, // eo function mut_call_getResourcesReportYearlyList()


    /***************************************************************************
    * mut_call_getResourcesFlightDutyTimeConfig()
    *
    * Desc: Build 'Flight Duty Time Config'.
    * Note:
    *
    */
    mut_call_getResourcesFlightDutyTimeConfig: (state, payload) => {

        let flights_ResourceDetails_FlightDutyTimeConfig_Copy = {},
            row_1 = [],
            row_2 = [],
            row_3 = [],
            row_4 = [],
            row_5 = [],
            row_6 = [],
            row_7 = [],
            row_8 = [],
            row_9 = [],
            row_10 = [],
            row_11 = [],
            row_12 = [],
            row_13 = [],
            row_14 = [],
            row_15 = [],
            col_max_fdt = null,
            row_max_fdt = null,
            formatted_max_fdt_extension = null,
            xyz = null;


        // >>> ----------------------------------------------------------------
        col_max_fdt = payload.context.state.flights_ResourceDetails_Brief.fdtInfo && payload.context.state.flights_ResourceDetails_Brief.fdtInfo.col_max_fdt;
        row_max_fdt = payload.context.state.flights_ResourceDetails_Brief.fdtInfo && payload.context.state.flights_ResourceDetails_Brief.fdtInfo.row_max_fdt;
        formatted_max_fdt_extension = payload.context.state.flights_ResourceDetails_Brief.fdtInfo && payload.context.state.flights_ResourceDetails_Brief.fdtInfo.formatted_max_fdt_extension;


        // >>> ----------------------------------------------------------------
        payload.response.forEach(fhs => {
            if (fhs.row === 1) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_1.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 2) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_2.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 3) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_3.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 4) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_4.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 5) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_5.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }
            if (fhs.row === 6) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_6.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 7) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_7.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }
            if (fhs.row === 8) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_8.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 9) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_9.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }
            if (fhs.row === 10) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_10.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 11) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_11.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }
            if (fhs.row === 12) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_12.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 13) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_13.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 14) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_14.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            if (fhs.row === 15) {
                if ((parseInt(fhs.row, 10) === parseInt(row_max_fdt, 10)) && (parseInt(fhs.col, 10) === parseInt(col_max_fdt, 10))) {
                    xyz = formatted_max_fdt_extension;
                } else {
                    xyz = null;
                }
                row_15.push({ row: fhs.row, col: fhs.col, value: fhs.value, formatted_max_fdt_extension: xyz });
            }

            xyz = null;
        });


        // >>> ----------------------------------------------------------------
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_1 = row_1;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_2 = row_2;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_3 = row_3;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_4 = row_4;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_5 = row_5;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_6 = row_6;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_7 = row_7;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_8 = row_8;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_9 = row_9;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_10 = row_10;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_11 = row_11;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_12 = row_12;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_13 = row_13;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_14 = row_14;
        flights_ResourceDetails_FlightDutyTimeConfig_Copy.row_15 = row_15;


        state.flights_ResourceDetails_FlightDutyTimeConfig = flights_ResourceDetails_FlightDutyTimeConfig_Copy;

    }, // eo function mut_call_getResourcesFlightDutyTimeConfig()




    /***************************************************************************
    * mut_set_changedDateInSavedPayload()
    *
    * Desc:
    * Note:
    *
    */
    mut_set_changedDateInSavedPayload: (state, payload) => {

        let flights_CrewDetails_SavedPayload_Copy = Object.assign({}, state.flights_CrewDetails_SavedPayload);


        flights_CrewDetails_SavedPayload_Copy.date = dayjs(payload.date).format('YYYY-MM-DDT23:59:59');


        state.flights_CrewDetails_SavedPayload = flights_CrewDetails_SavedPayload_Copy;

    }, // eo function mut_set_changedDateInSavedPayload()


    /*************************************************************************** // Reset
    * mut_reset_ResourceDetails()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_ResourceDetails: (state, payload) => {

        state.flights_ResourceDetails_ResourceAskedFor = {};
        state.flights_ResourceDetails_ResourceAskedFor_Date_EventRecord = null;
        // state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker = null;

        state.flights_ResourceDetails_Brief = [];
        state.flights_ResourceDetails_TrainingsList = [];

    }, // eo function mut_reset_ResourceDetails()


    /*************************************************************************** // Reset
    * mut_reset_ResourceAskedFor_Date_BriefPicker()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_ResourceAskedFor_Date_BriefPicker: (state, payload) => {

        state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker = null;

    }, // eo function mut_reset_ResourceAskedFor_Date_BriefPicker()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Flights' -  Load Scheduler Data
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/getlegsinfo4
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getLegsInfo: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        context.commit('mut_reset_SchedulerDataFlights', true); // reset scheduler flights

        axios.put('/humanresources/getlegsinfo4', payload.payload)
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getLegsInfo', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                // Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getLegsInfo()




    /***************************************************************************
    * Actions: 'Flights' - Set selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * actn_set_SelectedMultiEvents_Flights()
    *
    * Desc: Set selected Multi Events.
    * Note:
    *
    */
    actn_set_SelectedMultiEvents_Flights: (context, payload) => {

        context.commit('mut_set_SelectedMultiEvents_Flights', payload); // save data

    }, // eo function actn_set_SelectedMultiEvents_Flights()


    /***************************************************************************
    * actn_set_SelectedMultiResources_Flights()
    *
    * Desc: Set selected Multi Resources.
    * Note:
    *
    */
    actn_set_SelectedMultiResources_Flights: (context, payload) => {

        context.commit('mut_set_SelectedMultiResources_Flights', payload); // save data

    }, // eo function actn_set_SelectedMultiResources_Flights()




    /***************************************************************************
    * Actions: 'Flights' -  'Add CrewMember to Flights'
    ***************************************************************************/
    /*************************************************************************** 'delete'
    * Call::'humanresources/resource/flight/multi/modify2
    *
    * Desc: Delete ..
    * Note:
    *
    */
    actn_call_addCrewmemberOnFlights: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        context.commit('mut_reset_SelectedMultiEventsFlights', true); // reset selected flights

        axios.put('humanresources/resource/flight/multi/modify2', payload.params)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // if (payload.draggedRecords) {
                        //     eventBus.$emit('deletedraggedflightformember', payload.draggedRecords); // Emit 1: delete dragged one (from 'Calendar')
                        // }

                        // eventBus.$emit('createnewflightinflights', response.data.legInfoError.legs); // Emit 2: create new Flight (in 'Flights')
                        // eventBus.$emit('createnewflightformember', response.data.extends4); // Emit 3: create new Flight for Member (in 'Calendar')


                        // setTimeout(function(){
                        //     eventBus.$emit('updateflightsincalendarswithnewcrew', response.data.legInfoError.legs); // Emit 3: update flights in calendar (updated Crew)
                        // }, 500);



                        if (payload.draggedRecords) {
                            eventBus.$emit('deletedraggedflightformember', payload.draggedRecords); // Emit 1: delete dragged one (from 'Calendar')
                        }


                        setTimeout(function(){
                            eventBus.$emit('createnewflightformemberafterdelete', { response: response.data.extends4, params: payload.params }); // Emit create new Flight for Member (in 'Calendar')
                            eventBus.$emit('updateflightsinflightswithnewcrew', response.data.legInfoError.legs); // Emit: update flight in flight (updated Crew)
                        }, 750);

                        setTimeout(function(){
                            eventBus.$emit('updateflightsincalendarswithnewcrew', response.data.legInfoError.legs); // Emit 3: update flights in calendar (updated Crew)
                        }, 1000);

                        eventBus.$emit('deselectall');
                        eventBus.$emit('deselectallflights');
                        break;
                    default: // 'ERROR'
                        // >>> Backend Error on D&D, Turn bag everything
                        eventBus.$emit('deletedraggedflightformember', payload.draggedRecords); // Emit 1: delete dragged one (from 'Calendar')
                        eventBus.$emit('createnewflightinflights', payload.draggedRecords.map((record) => record.data.legInfo)); // Emit 3: create/reset new Flight (in 'Flights')

                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$vp_m();
                Vue.prototype.$vp_m();

                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_addCrewmemberOnFlights()


    /*************************************************************************** 'add'
    * Call::'humanresources/resource/flight/multi/modify2/delete
    *
    * Desc: Add ..
    * Note:
    *
    */
    actn_call_deleteCrewmemberFromFlights: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        context.commit('mut_reset_SelectedMultiEventsFlights', true); // reset selected flights

        axios.put('humanresources/resource/flight/multi/modify2/delete', payload.params)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        payload.params.idFlights = response.data.deletedFlights;
                        eventBus.$emit('deleteflightforcrewmember',  payload.params); // Emit: delete dragged one (from 'Calendar')

                        setTimeout(function(){
                            eventBus.$emit('createnewflightformemberafterdelete', { response: response.data.extends4, params: payload.params }); // Emit create new Flight for Member (in 'Calendar')
                            eventBus.$emit('updateflightsinflightswithnewcrew', response.data.legInfoError.legs); // Emit: update flight in flight (updated Crew)
                        }, 750);

                        eventBus.$emit('deselectall');
                        eventBus.$emit('deselectallflights');
                        break;
                    default: // 'ERROR'
                        eventBus.$emit('deselectall');
                        eventBus.$emit('deselectallflights');
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$vp_m();
                Vue.prototype.$vp_m();

                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_deleteCrewmemberFromFlights()


    /***************************************************************************
    * Call::'humanresources/resource/flight/multi/modify2
    *
    * Desc: Add & Delete .. one after the other. (from Edit Window)
    * Note:
    * TODO: We need anotehr Call Timing here.
    */
    actn_call_updateCrewmemberFromFlights: (context, payload) => {

        let addParams = JSON.parse(JSON.stringify(payload)),
            delParams = JSON.parse(JSON.stringify(payload)),
            gotMembersToAdd = payload.params.resourcesIdstoAdd.length > 0 ? true : false,
            gotMembersToDel = payload.params.resourcesIdstoRemove.length > 0 ? true : false;


        // >>> Call 1: Delete -------------------
        if (gotMembersToDel === true) {
            delParams.params.resourcesIdstoAdd = [];    // delete/reset
            context.dispatch("actn_call_deleteCrewmemberFromFlights", delParams);
        }

        if (gotMembersToAdd === true && gotMembersToDel === false) {
            addParams.params.resourcesIdstoRemove = []; // delete/reset
            context.dispatch("actn_call_addCrewmemberOnFlights", addParams);
        }

        if (gotMembersToAdd === true && gotMembersToDel === true) {
            addParams.params.resourcesIdstoRemove = []; // delete/reset
            setTimeout(function(){
                context.dispatch("actn_call_addCrewmemberOnFlights", addParams);
            }, 6200);
        }


        // >>> Close Sheet  ---------------------
        if (gotMembersToAdd === false && gotMembersToDel === true) {
            eventBus.$emit('crewswasupdatedcreated');
        }
        if (gotMembersToAdd === true) {
            setTimeout(function(){
                eventBus.$emit('crewswasupdatedcreated');
            }, 6200);
        }

    }, // eo function actn_call_updateCrewmemberFromFlights()


    /***************************************************************************
    * Call::'humanresources/resource/flight/multi/modify2
    *
    * Desc: Older ...
    * Note:
    *
    */
    actn_call_updateCrewmemberFromFlights_OLDER: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        context.commit('mut_reset_SelectedMultiEventsFlights', true); // reset selected flights

        axios.put('humanresources/resource/flight/multi/modify2', payload.params)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        if (payload.params.resourcesIdstoAdd.length > 0) {
                            eventBus.$emit('createnewflightformember', response.data.extends4); // Emit: create new Flight for Member (in 'Calendar')
                        }

                        if (payload.params.resourcesIdstoRemove.length > 0) {
                            eventBus.$emit('deleteflightforcrewmember',  payload.params); // Emit: delete dragged one (from 'Calendar')
                        }


                        eventBus.$emit('updateflightsinflightswithnewcrew', response.data.legInfoError.legs); // Emit: update flight in flight (updated Crew)
                        setTimeout(function(){
                            eventBus.$emit('updateflightsincalendarswithnewcrew', response.data.legInfoError.legs); // Emit: update flights in calendar (updated Crew)
                        }, 500);

                        eventBus.$emit('deselectall');
                        eventBus.$emit('deselectallflights');
                        eventBus.$emit('closeupdatecrewsheet');
                        eventBus.$emit('crewswasupdatedcreated'); // ja?
                        break;
                    default: // 'ERROR'
                        eventBus.$emit('deselectall');
                        eventBus.$emit('deselectallflights');
                        eventBus.$emit('closeupdatecrewsheet');
                        eventBus.$emit('crewswasupdatedcreated'); // ja?

                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCrewmemberFromFlights_OLDER()




    /***************************************************************************
    * Actions: 'Flights' -  Reset
    ***************************************************************************/
    /***************************************************************************
    * actn_reset_Flights()
    *
    * Desc:
    * Note:
    */
    actn_reset_Flights: (context, payload) => {

        context.commit('mut_reset_Flights');

    }, // eo function actn_reset_Flights()


    /***************************************************************************
    * actn_reset_DraggedFlightsInFlightsAndCalendar()
    *
    * Desc:
    * Note:
    *
    */
    actn_reset_DraggedFlightsInFlightsAndCalendar: (context, payload) => {

        eventBus.$emit('deletedraggedflightformember', payload.draggedRecords); // Emit 1: delete dragged one (from 'Calendar')
        eventBus.$emit('createnewflightinflights', payload.draggedRecords.map((record) => record.data.legInfo)); // Emit 3: create/reset new Flight (in 'Flights')

    }, // eof actn_reset_DraggedFlightsInFlightsAndCalendar()




    /***************************************************************************
    * Actions: 'Flights' - 'Crew Details' - 'Crew Member Details'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/resource/flight/568350'
    *
    * Desc: Get 'Crew Details'.
    * Note: Call 3 'DutiesCheck' directly after this Call.
    *
    */
    actn_call_getCrewDetailsFromFlight: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        state.flights_CrewDetails_HoursReport = []; // reset
        state.flights_CrewDetails_ErrorsOnResourceIsLoaded = false; // reset

        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('humanresources/resource/flight/' + payload.idFlight)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsFromFlightSavePayload', { payload: payload }); // save users payload
                        context.commit('mut_call_getCrewDetailsFromFlight', { payload: response.data, context: context }); // save

                        context.dispatch("actn_call_getCrewDetailsDutiesCheck", { // call: 'DutiesChecks', Call 3
                            payload: response.data,
                            date: payload.date,
                            from: payload.from,
                            to: payload.to,
                            idFlight: payload.idFlight
                        });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsFromFlight()


    /***************************************************************************
    * Call::'/humanresources/resource/flight/568350/reduced'
    *
    * Desc: Get 'Crew Details' (reduced).
    * Note:
    *
    */
    actn_call_getCrewDetailsFromFlight_Reduced: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.get('humanresources/resource/flight/' + payload.idFlight + '/reduced')
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsFromFlight_Reduced', { payload: response.data, context: context }); // save:
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsFromFlight_Reduced()


    /***************************************************************************
    * Call::'/humanresources/resource/dutiescheck'
    *
    * Desc: Get 'DutiesChecks'
    * Note: Gets 'dispatched' directly after Call 1.
    *
    */
    actn_call_getCrewDetailsDutiesCheck: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            payloadDutiesCheck = {
                date: null,
                idResources: []
            };


        // >>> Build Payload ------------------------------
        payloadDutiesCheck.date = payload.date;
        payload.payload.forEach(resource => {
            payloadDutiesCheck.idResources.push(resource.id)
        });

        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.put('humanresources/resource/dutiescheck', payloadDutiesCheck)
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsDutiesCheck', { payload: response.data, context: context }); // save

                        context.dispatch("actn_call_getCrewDetailsHoursReport", { // call: 'HoursReport', Call 4
                            resourcesIds: payloadDutiesCheck.idResources,
                            from: payload.from,
                            to: payload.to,
                            idFlight: payload.idFlight
                        });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsDutiesCheck()


    /***************************************************************************
    * Call::'/humanresources/resource/hours/report'
    *
    * Desc: Get 'Hours Report'
    * Note: Gets 'dispatched' directly after Call 1.
    *
    */
    actn_call_getCrewDetailsHoursReport: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            payloadHoursReport = {
                from: null,
                to: null,
                resourcesIds: []
            };


        // >>> Build Payload ------------------------------
        payloadHoursReport.from = payload.from;
        payloadHoursReport.to = payload.to;
        payloadHoursReport.resourcesIds = payload.resourcesIds; // was passed through

        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.put('humanresources/resource/hours/report', payloadHoursReport)
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsHoursReport', { payload: response.data, context: context, idFlight: payload.idFlight });

                        context.dispatch("actn_call_getValidateExtends", { // call: 'Validate Extends', Call 5
                            idFlight: payload.idFlight
                        });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsDutiesCheck()


    /***************************************************************************
    * Call::'/humanresources/validateextends/{idFlight}
    *
    * Desc: Get 'Validate Extends' Infos.
    * Note: Gets 'dispatched' directly after Call 4 (actn_call_getCrewDetailsHoursReport).
    *
    */
    actn_call_getValidateExtends: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.get('humanresources/validateextends/' + payload.idFlight )
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getValidateExtends', { payload: response.data, context: context, idFlight: payload.idFlight });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getValidateExtends()




    /***************************************************************************
    * Actions: 'Flights' - 'Resource Details'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/resource/brief'
    *
    * Desc: Get 'Resource Brief'.
    * Note:
    *
    */
    actn_call_getCrewDetailsResourceBrief: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            params = null;


        // >>> Reset --------------------------------------
        context.commit('mut_reset_ResourceDetails');

        // >>> Build --------------------------------------
        params = {
            date: context.state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker === null ? payload.payload.date : context.state.flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker,
            idResource: payload.payload.idResource
        };


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('humanresources/resource/brief', params)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsResourceBrief', { response: response.data, context: context, params: { idResource: payload.payload.idResource, contractBaseStationCode: payload.payload.contractBaseStationCode }, dateeventrecord: payload.payload.date });
                        eventBus.$emit('reloadvisibletab'); // emit: 'reload visible tab'
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsResourceBrief()

    /***************************************************************************
    * Call::'/humanresources/resource/brief'
    *
    * Desc: Get 'Resource Brief'.
    * Note: Only for Reload Brief.
    *
    */
    actn_call_getCrewDetailsResourceBrief_Reload: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            params = null;


        // >>> Build --------------------------------------
        params = {
            date: dayjs(payload.date).format('YYYY-MM-DDT00:00:00'),
            idResource: context.state.flights_ResourceDetails_ResourceAskedFor.idResource
        };


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('humanresources/resource/brief', params)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getCrewDetailsResourceBrief', { response: response.data, context: context, datebriefpicker: dayjs(payload.date).format('YYYY-MM-DDT00:00:00') });
                        eventBus.$emit('reloadvisibletab'); // emit: 'reload visible tab'
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewDetailsResourceBrief()


    /***************************************************************************
    * Call::'/humanresources/resource/training/list/139'
    *
    * Desc: Get Resources 'Trainings List'
    * Note: Tab 6
    *
    */
    actn_call_getResourcesTrainingsList: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            idResource = context.state.flights_ResourceDetails_ResourceAskedFor.idResource;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('humanresources/resource/training/list/' + idResource)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getResourcesTrainingsList', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesTrainingsList()


    /***************************************************************************
    * Call::'humanresources/resource/earlynightduties/yearly/14/{year}' (new: #587)
    *
    * Desc: Get Resources 'Early Night Duties Yearly'
    * Note: Tab 7
    *
    */
    actn_call_getResourcesEarlyNightDutiesYearlyList: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            idResource = context.state.flights_ResourceDetails_ResourceAskedFor.idResource;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('humanresources/resource/earlynightduties/yearly/' + idResource + '/' + payload.year)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getResourcesEarlyNightDutiesYearlyList', { response: response.data, context: context, year: payload.year });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesEarlyNightDutiesYearlyList()


    /***************************************************************************
    * Call::'humanresources/resource/report/yearly/289/{year}' (new: #587)
    *
    * Desc: Get Resources 'Reports Yearly'
    * Note: Tab 4/3
    *
    */
    actn_call_getResourcesReportYearlyList: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            idResource = context.state.flights_ResourceDetails_ResourceAskedFor.idResource;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('humanresources/resource/report/yearly/' + idResource + '/' + payload.year)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getResourcesReportYearlyList', { response: response.data, context: context, year: payload.year });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesReportYearlyList()


    /***************************************************************************
    * Call::'humanresources/config/fdt'
    *
    * Desc: Get Resources 'Flight Duty Time Config'
    * Note: Tab 2
    *
    */
    actn_call_getResourcesFlightDutyTimeConfig: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('humanresources/config/fdt/')
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getResourcesFlightDutyTimeConfig', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesFlightDutyTimeConfig()




    /***************************************************************************
    * actn_set_changedDateInSavedPayload()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_changedDateInSavedPayload: (context, payload) => {

        context.commit('mut_set_changedDateInSavedPayload', { date: payload.date, context: context });

    }, // eo function actn_set_changedDateInSavedPayload()


    /*************************************************************************** // Reset
    * actn_reset_getCrewDetailsResourceBrief
    *
    * Desc:
    * Note:
    *
    */
    actn_reset_getCrewDetailsResourceBrief: (context, payload) => {

        // >>> Reset --------------------------------------
        context.commit('mut_reset_ResourceDetails');

    }, // eo function actn_reset_getCrewDetailsResourceBrief()


    /*************************************************************************** // Reset
    * actn_reset_ResourceAskedFor_Date_BriefPicker
    *
    * Desc:
    * Note:
    *
    */
    actn_reset_ResourceAskedFor_Date_BriefPicker: (context, payload) => {

        // >>> Reset --------------------------------------
        context.commit('mut_reset_ResourceAskedFor_Date_BriefPicker');

    }, // eo function actn_reset_ResourceAskedFor_Date_BriefPicker()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
